import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'

import { connect } from 'react-redux'
import { dispatch, Dispatch, RootState, select, store } from '../../store'
import utilsStyles from '../../utils.scss'
import AuthModal from '../AuthModal'
import Avatar from '../Avatar'
import Brand from '../Brand'
import buttonSyles from '../Button/button.scss'
import { NavContainer, NavItem, NavLink } from '../Nav'
import navSyles from '../Nav/nav.scss'
import RemindDropdown from '../RemindDropdown'
import styles from './navbar.scss'

const cx = classnames.bind({
  ...utilsStyles,
  ...styles,
  ...navSyles,
  ...buttonSyles,
})

type IProps = Partial<ReturnType<typeof mapState>> &
  ReturnType<typeof mapDispatch>

class Navbar extends React.Component<IProps> {
  public state = {
    expandMenu: false,
    expandNotification: false
  }
  public handleMenuHide = () => {
    this.setState({ expandMenu: false })
  }
  public handleMenuShow = () => {
    this.setState({ expandMenu: true })
  }
  public handleMenuToggle = () => {
    this.setState({
      expandMenu: !this.state.expandMenu,
      expandNotification: false
    })
  }
  public handleNotificationToggle = () => {
    this.setState({
      expandNotification: !this.state.expandNotification,
      expandMenu: false
    })
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    if (nextProps.isAuthenticated) {
      this.setState({ showAuthModal: false })
      const rootState = store.getState()
      const currentUser = firebase.auth().currentUser
      if (
        currentUser &&
        select.users.getById(rootState, currentUser.uid) === null
      ) {
        dispatch.users.fetchUsers([currentUser.uid])
      }
    }
  }
  public render() {
    const {
      isAuthenticated,
      isAuthLoading,
      showAuthModal,
      onAuthModalClose
    } = this.props
    return (
      <div>
        {showAuthModal ? (
          <AuthModal active={showAuthModal} onCancel={onAuthModalClose} />
        ) : null}
        {isAuthLoading ? (
          <div className={cx('navbar', 'navbar_shadow')}>
            <Brand theme="dark" />
          </div>
        ) : isAuthenticated ? (
          this.renderAuthenticated(this.props)
        ) : (
              this.renderUnauthenticated(this.props)
            )}
      </div>
    )
  }
  public renderAuthenticated = (props: IProps) => {
    const { expandMenu, expandNotification } = this.state
    const rootState = store.getState()
    const currentUser = firebase.auth().currentUser
    const user = currentUser
      ? select.users.getById(rootState, currentUser.uid)
      : null

    return (
      <div className={cx('navbar', 'navbar_shadow')}>
        <Brand theme="dark" />
        {expandNotification ? <RemindDropdown /> : null}
        <div className={cx('navbar__collapse', { active: expandMenu })}>
          <NavContainer className={cx('nav', 'navbar__nav')}>
            <NavItem className={cx('nav__item')}>
              <NavLink to="/explore" className={cx('nav__link')}>
                探索講座
              </NavLink>
            </NavItem>
            <NavItem className={cx('nav__item')}>
              <NavLink to="/recruit" className={cx('nav__link')}>
                成為講者
              </NavLink>
            </NavItem>
            <NavItem className={cx('nav__item')}>
              <NavLink to="/lectures" className={cx('nav__link')}>
                我的講座
              </NavLink>
            </NavItem>
          </NavContainer>
          <hr className={cx('navbar__devide', 'navbar__item--desktop-hide')} />

          <NavContainer
            onMouseEnter={this.handleMenuShow}
            onMouseOut={this.handleMenuHide}
            className={cx(
              'nav',
              'navbar__nav',
              'navbar__user-list',
              'navbar__item--desktop-hide',
              { active: expandMenu }
            )}
          >
            <NavItem
              onMouseEnter={this.handleMenuShow}
              className={cx('nav__item')}
            >
              <NavLink
                onMouseEnter={this.handleMenuShow}
                to={currentUser ? `/users/${currentUser.uid}` : '#'}
                className={cx('nav__link')}
              >
                個人檔案
              </NavLink>
            </NavItem>
            <NavItem
              onMouseEnter={this.handleMenuShow}
              className={cx('nav__item')}
            >
              <NavLink
                onMouseEnter={this.handleMenuShow}
                to="/account"
                className={cx('nav__link')}
              >
                帳號設定
              </NavLink>
            </NavItem>
            <NavItem
              onMouseEnter={this.handleMenuShow}
              className={cx('nav__item')}
            >
              <NavLink
                onMouseEnter={this.handleMenuShow}
                to="/orders"
                className={cx('nav__link')}
              >
                訂單記錄
              </NavLink>
            </NavItem>
            <NavItem
              onMouseEnter={this.handleMenuShow}
              className={cx('nav__item')}
            >
              <NavLink
                onMouseEnter={this.handleMenuShow}
                to="/help"
                className={cx('nav__link')}
              >
                協助
              </NavLink>
            </NavItem>
            <NavItem
              onMouseEnter={this.handleMenuShow}
              className={cx('nav__item')}
            >
              <a
                onMouseEnter={this.handleMenuShow}
                href="#!"
                onClick={dispatch.auth.logout}
                className={cx('nav__link')}
              >
                登出
              </a>
            </NavItem>
          </NavContainer>
          <a
            onClick={this.handleNotificationToggle}
            className={cx(
              'navbar__remind-btn',
              'navbar__item--mobile-hide',
              'u-ml-16'
            )}
          >
            {this.props.numNotifications && this.props.numNotifications > 0 ? (
              <span className={cx('amount')}>
                {this.props.numNotifications}
              </span>
            ) : null}
          </a>
          <div className={cx('navbar__user')} onClick={this.handleMenuToggle}>
            <Avatar
              onMouseOver={this.handleMenuShow}
              readOnly={true}
              className={cx('nav-avatar')}
              userId={currentUser ? currentUser.uid : undefined}
            />
            <div className={cx('personal-info', 'desktop-hidden')}>
              <div>
                <h4 className={cx('user-name')}>
                  {user ? user.fullName : 'N/A'}
                </h4>
              </div>
              <p className={cx('welcome')}>歡迎回來</p>
            </div>
          </div>
        </div>
        <div className={cx('navbar__mobile-btns')}>
          <a
            onClick={this.handleNotificationToggle}
            className={cx('navbar__remind-btn', 'navbar__item--desktop-hide')}
          >
            {this.props.numNotifications && this.props.numNotifications > 0 ? (
              <span className={cx('amount')}>
                {this.props.numNotifications}
              </span>
            ) : null}
          </a>
          <div
            className={cx('navbar__toggle', { active: expandMenu })}
            onClick={this.handleMenuToggle}
          >
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    )
  }
  public renderUnauthenticated = ({ onAuthModalOpen }: IProps) => {
    const { expandMenu } = this.state
    return (
      <div className={cx('navbar', 'navbar_shadow')}>
        <Brand theme="dark" />
        <a
          href="#!"
          onClick={onAuthModalOpen}
          className={cx(
            'u-ml-16',
            'navbar__item--desktop-hide',
            'btn',
            'btn--primary',
            'btn--line'
          )}
        >
          登入 / 註冊
        </a>
        <div className={cx('navbar__collapse', { active: expandMenu })}>
          <NavContainer className={cx('nav', 'navbar__nav')}>
            <NavItem className={cx('nav__item')}>
              <NavLink to="/explore" className={cx('nav__link')}>
                探索講座
              </NavLink>
            </NavItem>
            <NavItem className={cx('nav__item')}>
              <NavLink to="/recruit" className={cx('nav__link')}>
                成為講者
              </NavLink>
            </NavItem>
            <li className={styles.nav__item}>
              <a
                href="#!"
                className={cx('navbtn', 'btn', 'btn--primary', 'btn--line')}
                onClick={onAuthModalOpen}
              >
                登入 / 註冊會員
              </a>
            </li>
          </NavContainer>
        </div>
        <div className={cx('navbar__mobile-btns')}>
          <div
            className={cx('navbar__toggle', { active: expandMenu })}
            onClick={this.handleMenuToggle}
          >
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    )
  }
}

const mapState = ({ auth, users, notifications, loading }: RootState) => {
  const rootState = store.getState()
  return {
    users,
    numNotifications: R.filter(
      payload => payload.notification.read === false,
      select.notifications.getNotifications(rootState)
    ).length,
    isAuthenticated: auth.isAuthenticated,
    isAuthLoading: loading.models.auth,
    showAuthModal: auth.showAuthModal
  }
}

const mapDispatch = (dispatch: Dispatch) => ({
  onAuthModalOpen: () => dispatch.auth.openAuthModal(),
  onAuthModalClose: () => dispatch.auth.closeAuthModal()
})

export default connect(
  mapState,
  mapDispatch
)(Navbar)



// WEBPACK FOOTER //
// ./src/components/Navbar/index.tsx